import { assign, createMachine } from 'xstate';
import { Context, Events } from './types';

export const cancelForm = createMachine<Context, Events>({
  id: 'cancelForm',
  predictableActionArguments: true,
  initial: 'idle',
  context: {
    churnReasons: [],
    cancellationConfirmation: null,
    cancellationMessage: null,
    cancellationChurnReasonCode: null,
    cancellationType: null,
    cancellationDate: null,
  },
  states: {
    idle: {
      on: {
        SET_FORM_VALUE: {
          actions: assign((ctx, e) => ({
            [e.name]: e.value,
          })),
        },
        GET_CHURN_REASON_CODES: {
          target: 'loading',
        },
      },
    },
    loading: {
      invoke: {
        src: 'getChurnReasonCodes',
        onDone: {
          target: 'idle',
          actions: assign({
            churnReasons: (_, event) => event.data.items,
            cancellationChurnReasonCode: (_, { data }) =>
              data.items.length === 1 ? data.items[0].code : null,
          }),
        },
        onError: {
          target: 'error',
        },
      },
    },
    error: {},
  },
});
